import sha256 from "crypto-js/sha256";
import { CONFIGS } from "@/constants";

export default {
  base64URLEncode(str) {
    return str
      .toString("base64")
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=/g, "");
  },

  generateRandomString(length) {
    let text = "";
    const possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  },

  requestCode(pkce = true, state: any = "") {
    if (pkce) {
      this.requestCodePkce(state);
    } else {
      this.requestCodeServe(state);
    }
  },

  requestCodePkce(state = "") {
    const randomCode = this.generateRandomString(32);
    const verifier = this.base64URLEncode(randomCode);
    const challenge = this.base64URLEncode(sha256(randomCode));
    localStorage.setItem("code-verifier", verifier);
    let url = `${CONFIGS.FOXONE_OAUTH_HOST}?client_id=${CONFIGS.FOX_CLIENT_ID}&scope=PHONE%3AREAD+PROFILE%3AREAD+ASSETS%3AREAD&code_challenge=${challenge}&response_type=code&code_challenge_method=S256`;
    if (state) {
      const str = encodeURIComponent(JSON.stringify(state));
      url += `&state=${str}`;
    }
    window.location.href = url;
  },

  requestCodeServe(state = "") {
    let url = `${CONFIGS.FOXONE_OAUTH_HOST}?client_id=${CONFIGS.FOX_CLIENT_ID}&scope=PROFILE%3AREAD+PHONE%3AREAD+ASSETS%3AREAD&response_type=code`;
    if (state) {
      const str = encodeURIComponent(JSON.stringify(state));
      url += `&state=${str}`;
    }
    window.location.href = url;
  }
};
